import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CallbackItem, SupervisorService } from '../../../core/services/supervisor.service';
import { restoreCsrTheme } from '../../csr/csr-theme';

@Component({
  selector: 'app-supervisor-callbacks',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './supervisor-callbacks.component.html',
  styleUrls: ['./supervisor-callbacks.component.scss'],
})
export class SupervisorCallbacksComponent implements OnInit, OnDestroy {
  statusFilter = 'ALL';
  openCount = 0;
  overdueCount = 0;
  callbacks: CallbackItem[] = [];
  toast = '';

  private readonly sub = new Subscription();
  private pollTimer?: ReturnType<typeof setInterval>;
  private toastTimer?: ReturnType<typeof setTimeout>;

  constructor(private readonly supervisor: SupervisorService) {}

  ngOnInit(): void {
    restoreCsrTheme();
    this.load();
    this.pollTimer = setInterval(() => this.load(), 20000);
    this.sub.add(this.supervisor.callbacks$.subscribe(summary => {
      this.openCount = summary.open;
      this.overdueCount = summary.overdue;
      this.callbacks = summary.callbacks;
    }));
  }

  ngOnDestroy(): void {
    if (this.pollTimer) clearInterval(this.pollTimer);
    if (this.toastTimer) clearTimeout(this.toastTimer);
    this.sub.unsubscribe();
  }

  load(): void {
    this.supervisor.fetchCallbacks(this.statusFilter);
  }

  setStatusFilter(status: string): void {
    this.statusFilter = status;
    this.load();
  }

  mark(call: CallbackItem, status: string): void {
    this.supervisor.updateCallbackStatus(call.callLogId, status);
    this.showToast(`Callback marked ${status.toLowerCase()}`);
  }

  statusClass(status: string): string {
    const normalized = (status || 'PENDING').toUpperCase();
    if (normalized === 'COMPLETED') return 'cb-done';
    if (normalized === 'SCHEDULED') return 'cb-scheduled';
    return 'cb-pending';
  }

  dueLabel(call: CallbackItem): string {
    if (!call.callbackDueAt) return 'No due time';
    const date = new Date(call.callbackDueAt);
    return Number.isNaN(date.getTime()) ? call.callbackDueAt : date.toLocaleString();
  }

  formatDuration(seconds: number): string {
    if (!seconds || seconds < 0) return '0:00';
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${String(secs).padStart(2, '0')}`;
  }

  private showToast(message: string): void {
    this.toast = message;
    if (this.toastTimer) clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(() => this.toast = '', 2500);
  }
}
